module.exports = __webpack_public_path__ + "static/media/filePdf.ac1614a0.PNG";